import { useAccount, useDisconnect } from 'wagmi'
import CloseImg from '@/assets/svg/close.svg'
import styled from "styled-components";
import { ReactSVG } from 'react-svg'
import {CopyToClipboard} from 'react-copy-to-clipboard';
import { masacAddress } from '@/utils/index'
import { useToastContext } from "@/contexts/ToastContext";

export default function DisConnect( { handleClose }) {
  const { address, connector } = useAccount()
  const { disconnect } = useDisconnect()  
  const { showToast } = useToastContext();
  console.log(connector);
  const onCopy = ()=>{
    showToast({
      dir:'top',
      type:'success',
      text:'Copied!'
    })
  }
  const toEthersScan = ()=>{
    window.open( `https://etherscan.io/address/${address}`, '_blank');
  }

  return (
    <Modal>
      <div className='close' onClick={handleClose}><ReactSVG src={CloseImg}/></div>
      <div className='content'>
        <div className='title'>Account</div>
        <div className='sub-title'>Connected with {connector?.name || 'MetaMask'}</div>
        <div className='info'>
          <div className='left'>
            {/* <div className='radius'></div> */}
            <span>{masacAddress(address)}</span>
          </div>
          <div className='dis-btn' onClick={disconnect}>Disconnect</div>
        </div>
        <div className='btns'>
          <CopyToClipboard text={address} onCopy={onCopy}>
            <div className='btn btn-hover-green'>Copy Address</div>
          </CopyToClipboard>
          <div className='btn' onClick={toEthersScan}>View on Explorer</div>
        </div>
      </div>      
    </Modal>
  )
}

const Modal = styled.div`
  width: 100%;
  height:100%;
  position: relative;
  .close{
    position: absolute;
    right: 30px;
    top: 23px;
    cursor: pointer;    
  }
  .content{
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    padding: 18px 22px 31px;
    box-sizing: border-box;
    .title{      
      font-weight: 600;
      font-size: 20px;
      line-height: 28px;
      color: #32DE86;
    }
  }
  .sub-title{
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    align-self: flex-start;
    color: rgba(255, 255, 255, 0.6);
    padding: 16px 0 11px;    
  }
  .info{
    display: flex;
    justify-content: space-between;
    background: rgba(255, 255, 255, 0.06);
    border-radius: 8px;
    height: 61px;
    width: 292px;
    align-items: center;
    padding: 17px 16px;
    box-sizing: border-box;
    background: rgba(255, 255, 255, 0.1);
    .left{
      display: flex;
      align-items: center;
      font-weight: 600;
      font-size: 18px;
      line-height: 22px;
      color: #32DE86;
    }
    .dis-btn{
      font-size: 16px;
      line-height: 22px;
      text-align: right;
      font-weight: 400;
      font-size: 16px;
      line-height: 20px;
      color: rgba(255, 255, 255, 0.6);
      cursor: pointer;
    }
    .radius{
      width: 21px;
      height: 21px;
      border-radius:50%;
      background: #fff;
      margin-right: 10px;
    }
  }
  .btns{
    display: flex;    
    margin-top: 31px;
    .btn{
      width: 138px;
      height: 44px;
      line-height: 44px;
      text-align: center;
      background: #32DE86;
      border-radius: 8px;
      cursor: pointer;
      font-weight: 600;
      font-size: 14px;
      &.btn-hover-green {
        &:hover{
          background:#239B5E; 
        }        
      }
      & + .btn{
        margin-left:12px;
        background: #404040;
      }
    }
  }
`